import { CHECKLIST_API_URL } from "../environment";
import { initAxiosFor } from "../security/axiosUtils";

export function useChecklistService() {
  const axiosInstance = initAxiosFor(CHECKLIST_API_URL);
  return {
    import: async (sourceTenantId: string, targetTenantId: string) => 
      (await axiosInstance.get(`${CHECKLIST_API_URL}/api/checklist/copy-from/${sourceTenantId}/to/${targetTenantId}`))?.data,
  }
}